// extracted by mini-css-extract-plugin
export default {"halfField":"ForgottenPassword_halfField__xzFBN"};